import React from "react";

const Calendar = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16663 11.7925H9.99996V15.1258"
        stroke="#70707B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 1.79248V5.12581"
        stroke="#70707B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49997 8.45947H17.5"
        stroke="#70707B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66663 1.79248V5.12581"
        stroke="#70707B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 3.45947H4.16664C3.24616 3.45947 2.49997 4.20566 2.49997 5.12614V16.7928C2.49997 17.7133 3.24616 18.4595 4.16664 18.4595H15.8333C16.7538 18.4595 17.5 17.7133 17.5 16.7928V5.12614C17.5 4.20566 16.7538 3.45947 15.8333 3.45947Z"
        stroke="#70707B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Calendar;
